<div>
    {{data.message}}
</div>